module.exports = __webpack_public_path__ + "img/op_img-carrusel-empresas.b14b01b.jpg";